module.exports = __webpack_public_path__ + "static/media/pic1.4da8584c.jpg";